import Swal from "sweetalert2";

export const loginAlert = ({ history, reduxChannel }) => {
	Swal.fire({
		customClass: "alert-custom",
		text: "로그인 후 이용 가능합니다.\n로그인 하러 가시겠습니까?",
		showCancelButton: true,
		confirmButtonText: "로그인 하러가기",
		cancelButtonText: "취소",
	}).then((result) => {
		if (result.isConfirmed) {
			let { pathname, search } = window.location;
			sessionStorage.setItem("backPage", pathname + search);
			history.push(`/together/channel/login?id=${reduxChannel?.influencer_id}`);
		}
	});
};

export const toastAlert = (text) => {
	Swal.fire({
		customClass: "alert-custom",
		text: text,
		confirmButtonText: "확인",
	});
};
